//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Line as LineChartGenerator } from "vue-chartjs/legacy";
import { cycledInt } from "~/assets/js/utils";
import colors from "~/assets/theme/colors";
import PopOver from "../../form/PopOver.vue";
import { plugins, scales } from "./config";

import {
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  Filler,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
);

export default {
  name: "MultiLineChart",
  components: {
    LineChartGenerator,
    PopOver,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    elements: {
      type: Object,
      default: () => ({}),
    },
    options: {
      type: Array,
      required: true,
    },
    height: {
      type: String,
      default: "h-88",
    },
    fill: {
      type: Boolean,
      default: true,
    },
    maintainAspectRatio: {
      type: Boolean,
      default: false,
    },
    responsive: {
      type: Boolean,
      default: true,
    },
    legend: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      range: this.options[0],
      currentLocale: null,
      legendLables: [],
    };
  },
  computed: {
    hasDatasets() {
      return this.elements?.datasets?.length > 0;
    },
    config() {
      const avaliableColors = [...Object.values(colors.primary), "#f2bc48"];
      const loopedCounter = cycledInt(5);
      const datasets = [];

      for (const dataset of this.elements.datasets) {
        const color = loopedCounter();
        datasets.push({
          backgroundColor: avaliableColors[color],
          fill: this.fill,
          borderWidth: 1,
          borderColor: avaliableColors[color],
          data: dataset.data.map((el) => el),
          tension: 0,
          label: dataset.label,
        });
      }

      return {
        chartData: {
          labels: this.elements.labels.map((el) => {
            return this.formatValue(el);
          }),
          datasets,
        },
        chartOptions: {
          maintainAspectRatio: this.maintainAspectRatio,
          responsive: this.responsive,
          plugins,
          tooltips: {
            position: "nearest",
            enabled: true,
            callbacks: {
              // eslint-disable-next-line @typescript-eslint/no-unused-vars
              label: (tooltipItems, data) => {
                const { datasetIndex, yLabel } = tooltipItems;
                const datasetLabel = this.elements.datasets[datasetIndex].label;

                const content = `${yLabel} ${datasetLabel}`;

                return content;
              },
            },
          },
          scales,
        },
      };
    },
  },
  created() {
    this.currentLocale = this.$i18n.locale;
  },
  methods: {
    onHasChanged() {
      this.$emit("hasChanged", this.range.value);
    },
    formatValue(el) {
      if (el.value && el.title) {
        return `${el.title} ${this.$d(new Date(el.value * 1000), "simple")}`;
      }
      return this.$d(new Date(el * 1000), "simple");
    },
  },
};
